import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ReactPaginate from "react-paginate";
import Select from "react-select";
import Breadcrumb from "../components/Breadcrumb";
import FuelPurchaseService from "../services/FuelPurchaseService";
import VendorService from "../services/VendorServices";
import ProjectService from "../services/ProjectService";
import StorageService from "../services/StorageService";
import MessageDialog from "../components/MessageDialog";
import Loading from "../components/loading";
import utility from "../utils/utility";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import { configSettings } from "../config/configSettings";

export default function AddFuelPurchase() {

    const [projects, setProjects] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [entries, setEntries] = useState([]);
    const [selectedEntry, setSelectedEntry] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [loading, setLoading] = useState(false);
    const [selectedType, setSelectedType] = useState("");
    const [availableFuel, setAvailableFuel] = useState(0);
    const [selectedProjectId, setSelectedProjectId] = useState("");
    const [editData, setEditData] = useState(null);
    const [message, setMessage] = useState("");
    const [msgType, setMsgType] = useState("error");
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;
    const emp = StorageService.loginData();
    const isAdmin = Number(emp.roleId) === 1 || Number(emp.roleId) === 2;

    const [saving, setSaving] = useState(false);
    const [receiptPreview, setReceiptPreview] = useState(null);
    const [receiptPreviewOld, setReceiptPreviewOld] = useState(null);
    const { register, reset, watch, handleSubmit, setValue, formState: { errors } } = useForm({
        mode: "onChange"
    });;

    const showMessage = (text, type = "success") => {
        setMessage(text);
        setMsgType(type);
    };

    const { permission, checkView, can } = usePermission(
        ScreenData.Fuel_Purchase,
        showMessage
    );

    useEffect(() => {
        if (permission) {
            checkView();
        }
    }, [permission]);

    useEffect(() => {
        if (permission) {
            if (checkView()) {
                loadProjects();
                loadVendors();
            }
        }
    }, [permission]);

    useEffect(() => {
        if (permission && Number(permission.canView) === 1) {
            loadEntries();
        }
    }, [selectedProjectId, selectedType, permission]);

    const loadProjects = async () => {
        const comp = StorageService.activeCompany();
        const employeeId = StorageService.loginData()?.employeeId;
        const res = await ProjectService.getActiveProjectsByEmployee(comp.companyId, employeeId);
        setProjects(res?.data || res || []);
    };

    const loadVendors = async () => {
        const res = await VendorService.getByCategory(1);
        setVendors(res?.data || []);
    };

    const loadEntries = async () => {
        setLoading(true); // ✅ start loader

        try {
            const res = await FuelPurchaseService.getAll({
                projectId: selectedProjectId,
                type: selectedType,
            });

            const sortedList = (res.data || []).sort(
                (a, b) => new Date(b.purchaseDate || 0) - new Date(a.purchaseDate || 0) || (b.id || 0) - (a.id || 0)
            );
            setEntries(sortedList);
            setAvailableFuel(res.availableFuel || 0);
            setCurrentPage(1);

        } catch (err) {
            setMessage("Failed to load data");
            setMsgType("error");
            setCurrentPage(1);
        }

        setLoading(false); // ✅ stop loader
    };

    // const loadEntries = async () => {
    //     const res = await FuelPurchaseService.getAll({
    //         projectId: selectedProjectId,
    //         type: selectedType,
    //     });

    //     setEntries(res.data || []);
    //     setAvailableFuel(res.availableFuel || 0);
    // };

    // AUTO AMOUNT
    const quantity = watch("fuelQuantityLiters");
    const rate = watch("costperLiter");

    useEffect(() => {
        const q = parseFloat(quantity);
        const r = parseFloat(rate);
        if (!isNaN(q) && !isNaN(r)) {
            setValue("amount", (q * r).toFixed(2));
        } else {
            setValue("amount", "");
        }
    }, [quantity, rate, setValue]);





    // OPEN MODAL
    const openAddModal = () => {
        reset({
            fuelType: "",
            fuelQuantityLiters: "",
            costperLiter: "",
            amount: "",
            vocherNo: "",
            purchaseDate: new Date().toISOString().split("T")[0],
        });
        setReceiptPreview(null);
        setReceiptPreviewOld(null);
        setSelectedEntry(null);
        setShowModal(true);
    };

    // SAVE
    const handleSave = async (data) => {
        if (!can("canAdd")) {
            showMessage("No permission to add", "error");
            return;
        }
        try {
            setSaving(true);
            const payload = {
                ...data,
                fuelReceiptURL: receiptPreview,
                roleId: Number(StorageService.loginData()?.roleId),
            };
            await FuelPurchaseService.create(payload);
            setMessage("Saved successfully");
            setMsgType("success");
            setShowModal(false);
            loadEntries();
        } catch (err) {
            setMessage(err?.response?.data?.message || "Error");
            setMsgType("error");
        } finally {
            setSaving(false); // ✅ stop loading
        }
    };

    const handleEdit = async () => {
        if (!selectedEntry) return;

        const data = await FuelPurchaseService.getById(selectedEntry.id);

        setEditData(data);

        if (data.fuelReceiptURL) {
            setReceiptPreviewOld(data.fuelReceiptURL);
            setReceiptPreview(
                `${configSettings.appURL}/uploads/fuelPurchase/${data.fuelReceiptURL}`
            );
        } else {
            setReceiptPreview(null);
            setReceiptPreviewOld(null);
        }

        reset({
            projectId: data.projectId,
            vendorId: data.vendorId,
            fuelType: data.fuleType,
            fuelQuantityLiters: data.fuelQuantityLiters,
            costperLiter: data.costperLiter,
            amount: data.amount,
            vocherNo: data.vocherNo,
            purchaseDate: data.purchaseDate?.split("T")[0],
        });

        setShowModal(true);
    };

    const handleUpdate = async (data) => {
        if (!can("canModify")) {
            showMessage("No permission to modify", "error");
            return;
        }
        try {
            setSaving(true);
            const payload = {
                ...data,
                fuelReceiptURL: receiptPreview,
                fuelReceiptURLOld: receiptPreviewOld,
                roleId: Number(StorageService.loginData()?.roleId),
            };
            await FuelPurchaseService.update(editData.id, payload);
            setMessage("Updated successfully");
            setMsgType("success");
            setShowModal(false);
            setEditData(null);
            loadEntries();
        } catch (err) {
            setMessage(err?.response?.data?.message || "Error");
            setMsgType("error");
        } finally {
            setSaving(false); // ✅ stop loading
        }
    };

    const handleReceiptUpload = (e) => {
        utility.readFile(e, setReceiptPreview, "fuelReceiptURL");
    };

    const handleDelete = async (id) => {
        if (!window.confirm("You need to delete this record?")) return;

        try {
            await FuelPurchaseService.remove(id);
            showMessage("Deleted successfully", "success");
            setSelectedEntry(null);
            loadEntries();
        } catch (err) {
            console.error(err);
            showMessage("Error deleting entry", "error");
        }
    };

    if (!permission || Number(permission.canView) !== 1) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                <Loading />
            </div>
        );
    }

    return (
        <>
            <Breadcrumb pageTitle="Fuel Purchase" secondTitle="Fuel" />


            <MessageDialog
                message={message}
                type={msgType}
                setMessage={setMessage}
                setMsgType={setMsgType}   // ✅ ADD THIS
            />

            <div className="card">


                <div className="card-header d-flex justify-content-between align-items-end">

                    {/* LEFT SIDE */}
                    <div className="d-flex align-items-end gap-3">

                        {/* PROJECT */}
                        <div style={{ minWidth: "280px" }}>
                            <label className="form-label mb-1">Project</label>
                            <Select
                                options={projects.map((p) => ({
                                    value: String(p.id),
                                    label: `${p.projectName} - ${p.projectCategoryName ? p.projectCategoryName + ' - ' : ''}${p.projectCode}`
                                }))}
                                value={
                                    selectedProjectId
                                        ? {
                                            value: String(selectedProjectId),
                                            label: (() => {
                                                const p = projects.find((x) => String(x.id) === String(selectedProjectId));
                                                return p ? `${p.projectName} - ${p.projectCategoryName ? p.projectCategoryName + ' - ' : ''}${p.projectCode}` : "";
                                            })()
                                        }
                                        : null
                                }
                                onChange={(opt) => {
                                    setSelectedProjectId(opt ? opt.value : "");
                                    setSelectedEntry(null);
                                }}
                                isSearchable={true}
                                isClearable={true}
                                placeholder="All Projects"
                                classNamePrefix="react-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    control: (base) => ({ ...base, minHeight: "38px" })
                                }}
                            />
                        </div>

                        {/* TYPE */}
                        <div>
                            <label className="form-label">Fuel Type</label>
                            <select
                                className="form-select"
                                style={{ width: "180px" }}
                                value={selectedType}
                                onChange={(e) => setSelectedType(e.target.value)}
                            >
                                <option value="">All Types</option>
                                <option value="PETROL">Petrol</option>
                                <option value="DIESEL">Diesel</option>
                                <option value="GAS">Gas</option>
                                <option value="OIL">Oil</option>
                            </select>
                        </div>

                        {/* AVAILABLE FUEL */}
                        <div>
                            <label className="form-label">Available Fuel</label>
                            <input
                                type="text"
                                className="form-control fw-bold"
                                style={{ width: "200px" }}
                                value={
                                    selectedType
                                        ? `${Number(availableFuel).toFixed(3)} Liters`
                                        : ""
                                }
                                disabled
                            />
                        </div>

                    </div>

                    {/* RIGHT SIDE BUTTONS */}
                    <div className="d-flex gap-2">
                        {can("canModify") && (
                            <button
                                className="btn btn-warning"
                                disabled={!selectedEntry}
                                onClick={handleEdit}
                            >
                                Modify
                            </button>
                        )}

                        {can("canAdd") && (
                            <button
                                className="btn btn-success"
                                onClick={openAddModal}
                            >
                                Add Purchase
                            </button>
                        )}
                    </div>

                </div>



                <div className="card-body">
                    <div className="table-responsive">
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Select</th>
                                    <th>Date</th>
                                    <th>Voucher No</th>
                                    <th>Project</th>
                                    <th>Vendor</th>
                                    <th>Fuel Type</th>
                                    <th className="text-end">Quantity</th>
                                    <th className="text-end">Rate/Liter</th>
                                    <th className="text-end">Amount</th>
                                    <th>Fuel Receipt</th>
                                    {can("canReject") && <th>Action</th>}
                                </tr>
                            </thead>

                            <tbody>

                                {loading ? (
                                    <tr>
                                        <td colSpan={can("canReject") ? "11" : "10"} className="text-center py-4">
                                            <Loading />
                                        </td>
                                    </tr>
                                ) : entries.length > 0 ? (
                                    entries.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage).map((e) => (
                                        <tr key={e.id}>
                                            <td>
                                                <input
                                                    type="radio"
                                                    checked={selectedEntry?.id === e.id}
                                                    onChange={() => setSelectedEntry(e)}
                                                />
                                            </td>

                                            <td>
                                                {utility.formatDateDDMMMYYYY(e.purchaseDate)}
                                            </td>

                                            {/* VOUCHER */}
                                            <td>{e.vocherNo}</td>

                                            {/* PROJECT */}
                                            <td>{e.projectName} - {e.projectCode}</td>

                                            {/* VENDOR */}
                                            <td>{e.vendorName}</td>

                                            {/* FUEL TYPE */}
                                            <td>{e.fuleType}</td>

                                            {/* QUANTITY */}
                                            <td className="text-end">{e.fuelQuantityLiters}</td>

                                            {/* RATE */}
                                            <td className="text-end">{e.costperLiter}</td>

                                            {/* AMOUNT */}
                                            <td className="text-end">{Number(e.amount || 0).toFixed(2)}</td>

                                            {/* FUEL RECEIPT */}
                                            <td>
                                                {e.fuelReceiptURL ? (
                                                    <a
                                                        href={`${configSettings.mediaURL}/get/fuelPurchase/${e.fuelReceiptURL}`}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        View
                                                    </a>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>

                                            {can("canReject") && (
                                                <td className="text-center align-middle">
                                                    {(() => {
                                                        const purchaseDateStr = e.purchaseDate ? new Date(e.purchaseDate).toLocaleDateString("en-CA") : "";
                                                        const todayStr = new Date().toLocaleDateString("en-CA");
                                                        const isDeletable = isAdmin || purchaseDateStr === todayStr;
                                                        return (
                                                            <button
                                                                className="btn btn-danger btn-sm"
                                                                title={isDeletable ? "Delete" : "Only today's records can be deleted"}
                                                                style={{
                                                                    opacity: isDeletable ? 1 : 0.4,
                                                                    cursor: isDeletable ? "pointer" : "not-allowed"
                                                                }}
                                                                disabled={!isDeletable}
                                                                onClick={(evt) => {
                                                                    evt.stopPropagation();
                                                                    if (isDeletable) {
                                                                        handleDelete(e.id);
                                                                    }
                                                                }}
                                                            >
                                                                <i className="ti ti-trash"></i>
                                                            </button>
                                                        );
                                                    })()}
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={can("canReject") ? "11" : "10"} className="text-center text-muted">
                                            No records found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <ReactPaginate
                        forcePage={Math.max(0, currentPage - 1)}
                        breakLabel="..."
                        nextLabel="Next >"
                        previousLabel="< Previous"
                        onPageChange={(e) => setCurrentPage(e.selected + 1)}
                        pageCount={Math.ceil(entries.length / itemsPerPage) || 1}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={2}
                        containerClassName="pagination-container"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        activeClassName="active"
                    />
                </div>
            </div>

            {/* MODAL */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,0.5)",
                        zIndex: 999,
                    }}
                >
                    <div
                        style={{
                            position: "fixed",
                            top: "55%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "700px",
                            background: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            maxHeight: "90vh",
                            overflowY: "auto",
                        }}
                    >


                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5>{editData ? "Modify Fuel Purchase" : "Add Fuel Purchase"}</h5>

                            <button
                                className="btn-close"
                                onClick={() => {
                                    setShowModal(false);
                                    setEditData(null);
                                    setSelectedEntry(null);
                                }}
                            ></button>
                        </div>


                        <div className="row g-3">


                            <div className="col-md-6 mb-3">
                                <label className="form-label">Project <span className="text-danger">*</span></label>
                                <Select
                                    options={projects.map((p) => ({
                                        value: String(p.id),
                                        label: `${p.projectName} - ${p.projectCategoryName ? p.projectCategoryName + ' - ' : ''}${p.projectCode}`
                                    }))}
                                    value={
                                        watch("projectId")
                                            ? {
                                                value: String(watch("projectId")),
                                                label: (() => {
                                                    const p = projects.find((x) => String(x.id) === String(watch("projectId")));
                                                    return p ? `${p.projectName} - ${p.projectCategoryName ? p.projectCategoryName + ' - ' : ''}${p.projectCode}` : "";
                                                })()
                                            }
                                            : null
                                    }
                                    onChange={(opt) => {
                                        setValue("projectId", opt ? opt.value : "", { shouldValidate: true });
                                    }}
                                    isSearchable={true}
                                    isClearable={true}
                                    placeholder="Select Project"
                                    classNamePrefix="react-select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 99999 }),
                                        control: (base) => ({
                                            ...base,
                                            minHeight: "38px",
                                            borderColor: errors.projectId ? "#dc3545" : base.borderColor
                                        })
                                    }}
                                />
                                <input type="hidden" {...register("projectId", { required: "Project is required" })} />
                                {errors.projectId && (
                                    <small className="text-danger">{errors.projectId.message || "Project is required"}</small>
                                )}
                            </div>


                            <div className="col-md-6 mb-3">
                                <label>Fuel Supplier <span className="text-danger">*</span></label>
                                <select
                                    className="form-select"
                                    {...register("vendorId", { required: "Vendor required" })}
                                >
                                    <option value="">Select Vendor</option>
                                    {vendors.map((v) => (
                                        <option key={v.id} value={v.id}>
                                            {v.vendorName}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className="col-md-6 mb-3">
                                <label>Fuel Type</label>
                                <select className="form-select" {...register("fuelType")}>
                                    <option value="">Select</option>
                                    <option value="DIESEL">Diesel</option>
                                    <option value="PETROL">Petrol</option>
                                    <option value="GAS">Gas</option>
                                    <option value="OIL">Oil</option>
                                </select>
                            </div>

                            <div className="col-md-6 mb-3">
                                <label>Quantity</label>
                                <input type="number" className="form-control"
                                    {...register("fuelQuantityLiters")} />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label>Cost per Liter</label>
                                <input type="number" className="form-control"
                                    {...register("costperLiter")} />
                            </div>

                            <div className="col-md-6 mb-3">
                                <label>Amount</label>
                                <input type="number" className="form-control"
                                    {...register("amount")} readOnly />
                            </div>


                            <div className="col-md-6 mb-3">
                                <label>
                                    Voucher No <span className="text-danger">*</span>
                                </label>

                                <input
                                    type="text"
                                    className={`form-control ${errors?.vocherNo ? "is-invalid" : ""}`}
                                    {...register("vocherNo", {
                                        required: "Voucher No is required",
                                        validate: (value) =>
                                            value.trim() !== "" || "Voucher No cannot be empty",
                                    })}
                                />

                                {errors?.vocherNo && (
                                    <div className="invalid-feedback">
                                        {errors.vocherNo.message}
                                    </div>
                                )}
                            </div>


                            <div className="col-md-6 mb-3">
                                <label>
                                    Date <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="date"
                                    className={`form-control ${errors.purchaseDate ? "is-invalid" : ""}`}
                                    {...register("purchaseDate", {
                                        required: "Date is required",
                                        validate: (value) => {
                                            const selected = value; // yyyy-mm-dd
                                            const today = new Date().toLocaleDateString("en-CA"); // yyyy-mm-dd

                                            if (selected > today) {
                                                return "Future date is not allowed";
                                            }

                                            const emp = StorageService.loginData();
                                            const isPrivileged =
                                                emp?.roleName === "Super Admin" ||
                                                emp?.roleName === "SuperAdmin" ||
                                                emp?.roleName === "Data Admin" ||
                                                emp?.roleName === "DataAdmin" ||
                                                Number(emp?.roleId) === 1 ||
                                                Number(emp?.roleId) === 2;

                                            if (!isPrivileged && selected < today) {
                                                return "Only Super Admin and Data Admin can select a past date";
                                            }
                                            return true;
                                        }
                                    })}
                                />
                                {errors.purchaseDate && (
                                    <small className="text-danger">
                                        {errors.purchaseDate.message}
                                    </small>
                                )}
                            </div>

                             {/* Fuel Receipt Image */}
                             <div className="col-md-6 mb-3">
                                 <label className="form-label">Fuel Receipt Image</label>
                                 <input
                                     type="file"
                                     accept="image/*,.pdf"
                                     className="form-control"
                                     onChange={handleReceiptUpload}
                                 />
                                 {receiptPreview && (
                                     (receiptPreview.startsWith("data:image/") || /\.(jpe?g|png|gif|webp|bmp)$/i.test(receiptPreview)) ? (
                                         <img
                                             src={receiptPreview}
                                             alt="Receipt Preview"
                                             className="mt-2 rounded"
                                             width="120"
                                             height="100"
                                             style={{ objectFit: "cover" }}
                                         />
                                     ) : (
                                         <div className="mt-2">
                                             <a
                                                 href={receiptPreview}
                                                 target="_blank"
                                                 rel="noreferrer"
                                                 className="d-inline-flex align-items-center gap-1"
                                                 style={{ textDecoration: "none" }}
                                             >
                                                 <span className="badge bg-secondary">PDF</span>
                                                 <span>View PDF</span>
                                             </a>
                                         </div>
                                     )
                                 )}
                             </div>

                        </div>

                        <div className="d-flex justify-content-end gap-2">
                            {editData ? (
                                can("canModify") && (
                                    <button
                                        className="btn btn-primary"
                                        disabled={saving}
                                        onClick={handleSubmit(handleUpdate)}
                                    >
                                        {saving ? "Updating..." : "Update"}
                                    </button>
                                )
                            ) : (
                                can("canAdd") && (
                                    <button
                                        className="btn btn-primary"
                                        disabled={saving}
                                        onClick={handleSubmit(handleSave)}
                                    >
                                        {saving ? "Saving..." : "Save"}
                                    </button>
                                )
                            )}

                            <button
                                className="btn btn-secondary"
                                onClick={() => {
                                    setShowModal(false);
                                    setEditData(null);
                                    setSelectedEntry(null);
                                }}
                            >
                                Cancel
                            </button>

                        </div>

                    </div>
                </div>
            )}
        </>
    );
}